export enum ObjectVariableLight {
	INTENSITY = 'intensity',
	COLOR = 'color',
}

// export enum ObjectVariableLightRaymarching {
// 	RAYMARCHING_PENUMBRA = 'raymarchingPenumbra',
// 	RAYMARCHING_SHADOW_BIAS_ANGLE = 'raymarchingShadowBiasAngle',
// 	RAYMARCHING_SHADOW_BIAS_DISTANCE = 'raymarchingShadowBiasDistance',
// }

export enum ObjectVariableAreaLight {
	WIDTH = 'width',
	HEIGHT = 'height',
}

export enum ObjectVariableDirectionalLight {
	DISTANCE = 'distance',
	SHADOW_BIAS = 'shadowBias',
	SHADOW_RADIUS = 'shadowRadius',
}
export enum ObjectVariableHemisphereLight {
	SKY_COLOR = 'skyColor',
	GROUND_COLOR = 'groundColor',
}

export enum ObjectVariablePointLight {
	DECAY = 'decay',
	DISTANCE = 'distance',
	SHADOW_BIAS = 'shadowBias',
	SHADOW_NEAR = 'shadowNear',
	SHADOW_FAR = 'shadowFar',
}

export enum ObjectVariableSpotLight {
	ANGLE = 'angle',
	PENUMBRA = 'penumbra',
	DECAY = 'decay',
	DISTANCE = 'distance',
	SHADOW_BIAS = 'shadowBias',
	SHADOW_NEAR = 'shadowNear',
	SHADOW_FAR = 'shadowFar',
	SHADOW_RADIUS = 'shadowRadius',
}
